import { FoodContext } from "../context/FoodContext";
import { useContext } from "react";

export const useFoodContext = () => {
    const context = useContext(FoodContext);

    if (!context) {
        return Error('useFoodContext must be used inside an FoodContextProvider');
    };

    return context;
};